import { pickBy } from 'lodash';
import axios from 'axios';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

let cancelTokenSettings;
let cancelTokenGeneral;
let cancelTokenProviders;
let cancelTokenIntegrations;
let cancelTokenNotifications;
let cancelTokenSignup;
let cancelTokenBonuses;
let cancelTokenPayments;
export const getSettingsConfig = (payload) => {
  if (typeof cancelTokenSettings !== typeof undefined) {
    cancelTokenSettings.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenSettings = axios.CancelToken.source();
  return axiosInstance.get('/settings/configuration', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenSettings.token,
  });
};

export const getGeneralList = (payload) => {
  if (typeof cancelTokenGeneral !== typeof undefined) {
    cancelTokenGeneral.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenGeneral = axios.CancelToken.source();
  return axiosInstance.get('/settings/general/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenGeneral.token,
  });
};

export const saveGeneral = (payload) => axiosInstance.post('/settings/general/save', { ...payload, ...pickDevParams });

export const uploadLogo = (payload) => axiosInstance.post('/settings/logo/upload', payload, {
  params: pickDevParams,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const removeLogo = () => axiosInstance.post('/settings/remove/logo', pickDevParams);

export const uploadFavicon = (payload) => axiosInstance.post('/settings/favicon/upload', payload, {
  params: pickDevParams,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const removeFavicon = () => axiosInstance.post('/settings/remove/favicon', pickDevParams);

export const uploadSitemap = (payload) => axiosInstance.post('/settings/sitemap/upload', payload, {
  params: pickDevParams,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const removeSitemap = () => axiosInstance.post('/settings/remove/sitemap', pickDevParams);

export const uploadRobots = (payload) => axiosInstance.post('/settings/robots/upload', payload, {
  params: pickDevParams,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const removeRobots = () => axiosInstance.post('/settings/remove/robots', pickDevParams);

export const getProvidersList = (payload) => {
  if (typeof cancelTokenProviders !== typeof undefined) {
    cancelTokenProviders.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenProviders = axios.CancelToken.source();
  return axiosInstance.get('/settings/providers/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenProviders.token,
  });
};

export const getProvidersBalance = (payload, cancelToken) => axiosInstance.post('/settings/providers/balance', payload, {
  params: pickDevParams,
  cancelToken,
});

export const addProvider = (payload) => axiosInstance.post('/settings/providers/add', { ...payload, ...pickDevParams });

export const editProvider = (id, payload) => axiosInstance.post(`/settings/providers/edit/${id}`, { ...payload, ...pickDevParams });

export const deleteProvider = (id) => axiosInstance.post(`/settings/providers/delete/${id}`, pickDevParams);

export const apiKeyLog = (id) => axiosInstance.post(`/settings/providers/apikey-log/${id}`, pickDevParams);

export const getPaymentsList = (payload) => {
  if (typeof cancelTokenPayments !== typeof undefined) {
    cancelTokenPayments.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenPayments = axios.CancelToken.source();
  return axiosInstance.get('/settings/payments/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenPayments.token,
  });
};

export const getPaymentsMethodsList = () => axiosInstance.get('/settings/payments/methods/available/list', {
  params: pickDevParams,
});

export const getPayment = (id) => axiosInstance.get(`/settings/payments/get/${id}`, {
  params: pickDevParams,
});

export const addPayment = (method_id) => axiosInstance.post('/settings/payments/add', { method_id }, { params: pickDevParams });

export const editPayment = (id, payload) => axiosInstance.post(`/settings/payments/edit/${id}`, payload, { params: pickDevParams });

export const sortPayments = (id, position) => axiosInstance.post(`/settings/payments/sort/${id}`, { position }, { params: pickDevParams });

export const toggleVisibilityPayment = (id, visible) => axiosInstance.post(`/settings/payments/toggle/visibility/${id}`, { visible }, { params: pickDevParams });

export const togglePossibilityOfUsePayment = (id, possibility) => axiosInstance.post(`/settings/payments/toggle/possibility-of-use/${id}`, { possibility }, { params: pickDevParams });
export const getModulesList = (payload) => {
  if (typeof cancelTokenProviders !== typeof undefined) {
    cancelTokenProviders.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenProviders = axios.CancelToken.source();
  return axiosInstance.get('/settings/modules/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenProviders.token,
  });
};

export const activateModule = (id, payload) => axiosInstance.post(`/settings/modules/activate/${id}`, { ...payload, ...pickDevParams });

export const editModule = (id, payload) => axiosInstance.post(`/settings/modules/edit/${id}`, { ...payload, ...pickDevParams });

export const deactivateModule = (id) => axiosInstance.post(`/settings/modules/deactivate/${id}`, pickDevParams);

export const getIntegrationsList = (payload) => {
  if (typeof cancelTokenIntegrations !== typeof undefined) {
    cancelTokenIntegrations.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenIntegrations = axios.CancelToken.source();
  return axiosInstance.get('/settings/integrations/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenIntegrations.token,
  });
};

export const editIntegration = (id, payload) => axiosInstance.post(`/settings/integrations/edit/${id}`, payload, { params: pickDevParams });

export const deactivateIntegration = (id) => axiosInstance.post(`/settings/integrations/deactivate/${id}`, pickDevParams);

export const getNotificationsList = (payload) => {
  if (typeof cancelTokenNotifications !== typeof undefined) {
    cancelTokenNotifications.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenNotifications = axios.CancelToken.source();
  return axiosInstance.get('/settings/notifications/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenNotifications.token,
  });
};

export const getNotificationView = (id, payload) => axiosInstance.get(`/settings/notifications/view/${id}`, {
  params: { ...payload, ...pickDevParams },
});

export const toggleNotificationStatus = (id, payload) => axiosInstance.post(`/settings/notifications/toggle/status/${id}`, payload, { params: pickDevParams });

export const editNotification = (id, payload) => axiosInstance.post(`/settings/notifications/edit/${id}`, payload, { params: pickDevParams });

export const resetNotification = (id, payload) => axiosInstance.post(`/settings/notifications/reset/${id}`, payload, { params: pickDevParams });

export const addNotificationStaffEmail = (payload) => axiosInstance.post('/settings/notifications/staff/email/add', payload, { params: pickDevParams });

export const editNotificationStaffEmail = (id, payload) => axiosInstance.post(`/settings/notifications/staff/email/edit/${id}`, payload, { params: pickDevParams });

export const deleteNotificationStaffEmail = (id) => axiosInstance.post(`/settings/notifications/staff/email/delete/${id}`, pickDevParams);

export const resendNotificationStaffEmailConfirm = (id) => axiosInstance.post(`/settings/notifications/staff/resend-confirmation/${id}`, pickDevParams);

export const connectTelegramBotNotification = (payload) => axiosInstance.post('/settings/notifications/bots/telegram/connect', payload, { params: pickDevParams });

export const editTelegramBotNotification = (id, payload) => axiosInstance.post(`/settings/notifications/bots/telegram/token/edit/${id}`, payload, { params: pickDevParams });

export const deteleTGBotNotification = (id) => axiosInstance.post(`/settings/notifications/bots/telegram/delete/${id}`, pickDevParams);

export const checkStatusTelegramBotNotification = (id) => axiosInstance.get(`/settings/notifications/bots/telegram/webhook/status/${id}`, { params: pickDevParams });

export const getSignupList = (payload) => {
  if (typeof cancelTokenSignup !== typeof undefined) {
    cancelTokenSignup.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenSignup = axios.CancelToken.source();
  return axiosInstance.get('/settings/signup/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenSignup.token,
  });
};

export const sortSignup = (id, position) => axiosInstance.post(`/settings/signup/sort/${id}`, { position }, { params: pickDevParams });

export const addSignup = (id, payload) => axiosInstance.post(`/settings/signup/add/${id}`, payload, { params: pickDevParams });

export const editSignup = (id, payload) => axiosInstance.post(`/settings/signup/edit/${id}`, payload, { params: pickDevParams });

export const deleteSignup = (id) => axiosInstance.post(`/settings/signup/delete/${id}`, pickDevParams);

export const getBonusesList = (payload) => {
  if (typeof cancelTokenBonuses !== typeof undefined) {
    cancelTokenBonuses.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenBonuses = axios.CancelToken.source();
  return axiosInstance.get('/settings/bonuses/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenBonuses.token,
  });
};

export const addBonus = (payload) => axiosInstance.post('/settings/bonuses/add', payload, { params: pickDevParams });

export const editBonus = (id, payload) => axiosInstance.post(`/settings/bonuses/edit/${id}`, payload, { params: pickDevParams });

/*
   Settings - Ticket form
 */
export const ticketFormList = () => axiosInstance.get('/settings/ticket/list', {
  params: { ...pickDevParams },
});
export const ticketFormCategoryAdd = (payload) => axiosInstance.post('/settings/ticket/category/add', payload, { params: pickDevParams });
export const ticketFormCategoryEdit = (id, payload) => axiosInstance.post(`/settings/ticket/category/edit/${id}`, payload, { params: pickDevParams });
export const ticketFormCategoryDelete = (id) => axiosInstance.post(`/settings/ticket/category/delete/${id}`, {}, { params: pickDevParams });
export const ticketFormCategory = (query) => axiosInstance.get('/settings/ticket/get-form', {
  params: { ...query, ...pickDevParams },
});
export const ticketFormSubcategoryAdd = (parentId, payload) => axiosInstance.post(`/settings/ticket/subcategory/add/${parentId}`, payload, { params: pickDevParams });
export const ticketFormSubcategoryEdit = (id, payload) => axiosInstance.post(`/settings/ticket/subcategory/edit/${id}`, payload, { params: pickDevParams });
export const ticketFormSubcategoryDelete = (id) => axiosInstance.post(`/settings/ticket/subcategory/delete/${id}`, {}, { params: pickDevParams });
export const ticketFormFieldAdd = (parentId, payload) => axiosInstance.post(`/settings/ticket/field/add/${parentId}`, payload, { params: pickDevParams });
export const ticketFormFieldEdit = (id, payload) => axiosInstance.post(`/settings/ticket/field/edit/${id}`, payload, { params: pickDevParams });
export const ticketFormFieldDelete = (id) => axiosInstance.post(`/settings/ticket/field/delete/${id}`, {}, { params: pickDevParams });
export const ticketFormCategoryChangePosition = (payload) => axiosInstance.post('/settings/ticket/category/change-position', payload, { params: pickDevParams });
export const ticketFormChangePosition = (parentId, payload) => axiosInstance.post(`/settings/ticket/change-position/${parentId}`, payload, { params: pickDevParams });
export const getUserLevels = (id, payload) => axiosInstance.get('/settings/user-levels/list', {
  params: { ...payload, ...pickDevParams },
});

export const levelsAffectedUsers = (payload) => axiosInstance.get('/settings/user-levels/affected-users', {
  params: { ...payload, ...pickDevParams },
});
export const levelsActivate = (payload) => axiosInstance.post('/settings/user-levels/activate', { ...payload, ...pickDevParams });
